//
// CurationInstitutionListParams actions.
//

// Redux store update for curation institution list params.
export const setCurationInstitutionListParams = (params) => {
  return {
    type: 'SET_CURATIONINSTITUTIONLISTPARAMS',
    params
  };
};
